export default "__VITE_ASSET__CX6TOzP4__"